import Vue from 'vue'

Vue.filter('moneyformat', function (value) {

    if (!value) return 0

    value = parseFloat(value);

    return value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
});

Vue.filter('dateFormat', function(value) {

    if (!value) return null

    return moment(value).format("ddd, MMM,Do, h:mm a")
});

Vue.filter('diffFromNow', function(value) {

    if (! value) return null

    let now = moment(new Date());

    let end = moment(value);

    return moment.duration(end.diff(now)).humanize();
});

Vue.filter('dayDateFormat', function(value) {

    if (!value) return null;

    return moment(value).format("ddd, MMM D")
});

